

import { initUploader } from "@/modules/uploader";
import WOW from "wowjs";
import { Slicker } from '@rooi/slicker/esm2015/index';
import Swiper from 'swiper';
import { EffectFade, Pagination, Navigation } from 'swiper/modules';
import { slideDown, slideUp, isVisible } from 'slide-anim';
import attrs from 'attrs';
import Cookies from 'js-cookie';
import { initFooterSection } from "@/modules/section-footer";
import ready from "@/scripts/helpers/dom/ready";
import cookiePopup from "@/modules/popup-cookie";
import { clickTracker, sendMetricAsync } from "@/scripts/helpers/clickTracker";
import handleScroll from "@/modules/section-header";

const pageUrl = new URL(window.location.href);
const pageUrlNoDomain = pageUrl.pathname;

const initWowLibrary = () => {
	window.wow = new WOW.WOW({
		offset: 100,
		live: false
	});
	window.wow.resetAnimation = function() {};
	window.wow.init();
};

const partnersSlider = new Slicker(document.querySelector('.partners.js-slider'), {
	dots: false,
	arrows: false,
	infinite: true,
	speed: 6000,
	autoplaySpeed: 0,
	slidesToScroll: 1,
	centerMode: false,
	variableWidth: true,
	draggable: true,
	autoplay: true,
	swipeToSlide: true,
	pauseOnHover: false,
	fade: false,
	cssEase: 'linear',
	useTransform: false
});

const overviewSlider = new Slicker(document.querySelector('.js-slider--overview'), {
	dots: true,
	arrows: false,
	infinite: false,
	initialSlide: 0,
	speed: 0,
	autoplaySpeed: 5000,
	slidesToShow: 1,
	slidesToScroll: 1,
	centerMode: false,
	variableWidth: false,
	draggable: false,
	autoplay: true,
	adaptiveHeight: true
});

const featuresSlider = new Swiper('.js-slider--features-viewport', {
	spaceBetween: 30,
	slidersPerView: 1,
	initialSlide: 0,
	effect: 'fade',
	fadeEffect: { crossFade: true },
	modules: [EffectFade]
});

const workflowSlider = new Swiper('.js-slider--workflow', {
	spaceBetween: 30,
	slidersPerView: 1,
	autoHeight: true,
	effect: 'fade',
	fadeEffect: { crossFade: true },
	modules: [EffectFade, Pagination, Navigation],
	pagination: {
		el: ".page-counter",
		type: "fraction",
	},
	navigation: {
		nextEl: '.next',
		prevEl: '.prev',
	},
});

const accordion = () => {
	const elements = document.querySelectorAll('.accordion');

	elements.forEach(element => {
		const triggers = element.querySelectorAll('.accordion__panel-title, .accordion__panel-status');
		const panels = element.querySelectorAll('.accordion__panel-body');
		let isAccordionDisabled = false;

		const initPanels = () => {
			panels.forEach(panel => {
				const title = panel.previousElementSibling;
				if (!isVisible(panel) && title.getAttribute('aria-selected') === 'true') {
					slideDown(panel);
				};
				if (isVisible(panel) && title.getAttribute('aria-selected') !== 'true') {
					slideUp(panel);
				};
			});
		};

		const openAccordion = () => {
			panels.forEach(panel => {
				const title = panel.previousElementSibling;

				if (!isVisible(panel)) {
					slideDown(panel);

					attrs(title, {
						'aria-selected': true
					})
				}
			});
		};

		const collapseAccordion = () => {
			panels.forEach(panel => {
				const title = panel.previousElementSibling;

				if (isVisible(panel)) {
					slideUp(panel);

					attrs(title, {
						'aria-selected': false
					});
				}
			});
		};

		const handlePanelsToggle = event => {
			let trigger = event.target;

			if (trigger.classList.contains('accordion__panel-status')) {
				trigger = trigger.parentNode;
			}

			const panel = trigger.nextElementSibling;

			if (isAccordionDisabled || trigger.parentNode.classList.contains('slide-navigation')) return;
			if (event.key && event.key !== 'Enter') return;

			if (isVisible(panel)) {
				slideUp(panel);
				attrs(trigger, {
					'aria-selected': false
				})
			} else {
				slideDown(panel);
				attrs(trigger, {
					'aria-selected': true
				})
			}

			isAccordionDisabled = true;
			setTimeout(() => {
				isAccordionDisabled = false;
			}, 400);

			if (element.getAttribute("aria-multiselectable") !== "true") {
				collapseAccordion();
			}
		};

		triggers.forEach(trigger => {
			trigger.addEventListener('click', handlePanelsToggle);
			trigger.addEventListener('keyup', handlePanelsToggle);
		});

		initPanels();

		if (element.dataset.openedPanels === 'true') {
			openAccordion();
		};
	});
};

const featuresItems = document.querySelectorAll('.slide-navigation');
const scrollContainer = document.querySelector('.navigation-accordion');

featuresItems.forEach((panel, index) => {
	panel.addEventListener('click', (e) => {
		const panelTitle = panel.querySelector('.accordion__panel-title');
		if (panelTitle.getAttribute('aria-selected') === 'true') {
			e.preventDefault();
		}
		featuresSlider.slideTo(index);
	});
});

featuresSlider.on('slideChange', function () {
	const activeSlideIndex = featuresSlider.activeIndex;
	const currentSlide = featuresSlider.slides[activeSlideIndex];
	const slideImages = currentSlide.querySelectorAll('.slide-img');

	slideImages.forEach(image => {
		image.style.display = 'none';
	});

	featuresItems.forEach((panel, index) => {
		const panelTitle = panel.querySelector('.accordion__panel-title');

		if (index === activeSlideIndex) {
			panelTitle.setAttribute('aria-selected', 'true');
		} else {
			panelTitle.setAttribute('aria-selected', 'false');
		}
	});
});

featuresSlider.on('slideChangeTransitionEnd', function () {
	const activeSlideIndex = featuresSlider.activeIndex;
	const currentSlide = featuresSlider.slides[activeSlideIndex];
	
	const slideImages = currentSlide.querySelectorAll('.slide-img');
	slideImages.forEach(image => {
		image.style.display = 'block';
	});
});


function updatePanels() {
	const featuresPanels = document.querySelectorAll('.features-slider__navigation .accordion__panel');

	featuresPanels.forEach(panel => {
		const panelTitle = panel.querySelector('.accordion__panel-title');
		const panelBody = panel.querySelector('.accordion__panel-body');

		if (panelTitle.getAttribute('aria-selected') === 'true') {
			panel.classList.add('is-open');
			const panelOffsetLeft = panel.offsetLeft;
			const scrollCenter = panelOffsetLeft - scrollContainer.clientWidth / 2 + panel.clientWidth / 2;

			scrollContainer.scroll({
				left: scrollCenter,
				behavior: 'smooth',
			});
			slideDown(panelBody);

		} else {
			panel.classList.remove('is-open');
			slideUp(panelBody);
		}
	})
};

function observePanelTitleChanges() {
	const panelTitles = document.querySelectorAll('.accordion__panel-title');
	const observer = new MutationObserver(() => {
		updatePanels();
	});

	panelTitles.forEach(title => {
		observer.observe(title, { attributes: true, attributeFilter: ['aria-selected'] });
	});
}

window.clickTracker = clickTracker;

function googleOneTapInit() {
	window.onGoogleLibraryLoad = () => {
		// Cookies.remove("g_state");

		const clientID = '1179802238-202ueh12c57itr8t99rlpp8tem3s5bk8.apps.googleusercontent.com'; // PROD
		// const clientID = '714104528245-e2cgo2oi7r37iqg409ec51ectde54j74.apps.googleusercontent.com'; // DEV

		google.accounts.id.initialize({
			client_id: clientID,
			callback: handleCredentialResponse,
			cancel_on_tap_outside: false,
			// state_cookie_domain: 'www.dochub.com',
			auto_prompt: "true",
			context: "signin",
			itp_support: "true"
		});

		google.accounts.id.prompt((notification) => {
			if (notification.isNotDisplayed()) {
				let reason = notification.getNotDisplayedReason();
				const metrics = {
					dataDog: 'dh_google_one_tap_error_show_reason',
					data: {
						reason: reason,
						page_url: pageUrlNoDomain
					}
				};

				sendMetricAsync(metrics);

			} else if (notification.isSkippedMoment()) {
				let reason = notification.getSkippedReason();
				const metrics = {
					dataDog: 'dh_google_one_tap_error_show_reason',
					data: {
						reason: reason,
						page_url: pageUrlNoDomain
					}
				};

				sendMetricAsync(metrics);

			} else if (notification.isDismissedMoment() && notification.getDismissedReason() !== 'credential_returned') {
				let reason = notification.getDismissedReason();
				const metrics = {
					dataDog: 'dh_google_one_tap_error_show_reason',
					data: {
						reason: reason,
						page_url: pageUrlNoDomain
					}
				};

				sendMetricAsync(metrics);
				
			} else {
				const metrics = {
					dataDog: 'dh_google_one_tap_show',
					data: {
						page_url: pageUrlNoDomain
					}
				};

				sendMetricAsync(metrics);
			}
		})
	 };
};

function handleCredentialResponse(data) {
	const path = 'https://dochub.com/google-one-tap'; // PROD
	// const path = 'https://staging.dochub.com/google-one-tap'; // DEV

	const metrics = {
		dataDog: 'dh_google_one_tap_click',
		abTower: 'dh_lp_google_one_tap_click',
		data: {
			page_url: pageUrlNoDomain
		}
	};

	sendMetricAsync(metrics);

	fetch(path, {
		method: 'POST',
		headers: {'Content-Type': 'application/json'},
		body: JSON.stringify({credential: data.credential}),
		credentials: 'include'
	})
	.then((resp) => {
		if (resp.status === 204 || resp.status === 200) {
			const pathUrl = 'https://dochub.com';

			window.location.href = pathUrl;
		} else {console.log('One Tap callback - response:', resp.status);}
	})
	.catch(error => {
		const	metrics = {
			dataDog: 'dh_google_one_tap_error_login_reason',
			data: {
				page_url: pageUrlNoDomain
			}
		};

		console.error('One Tap callback - error:', error);
		sendMetricAsync(metrics);
	});
}

ready( () => {
	if (window.dropArea) {
		initUploader();
	};
	initWowLibrary();
	accordion();
	updatePanels();
	observePanelTitleChanges();
	window.clickTracker();
	initFooterSection();
	googleOneTapInit();
	setTimeout(() => {
		cookiePopup();
	}, 4000);
});